import { gql } from 'apollo-angular';

export const AZURE_LOGIN_MUTATION = gql`
  mutation azureLogin($token: String!) {
    azureLogin(token: $token) {
      accessToken
      refreshToken
    }
  }
`;
